/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import { makeSelectVirtualizedTableColumnUnit } from 'services/virtualizedTable/selectors';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';

import { makeSelectFooterSummaryValue } from './selectors';

export interface OwnProps {
    columnKey: VirtualizedTableColumnKey;
}

export interface ConnectedProps {
    footerSummaryValue?: ReturnType<
        ReturnType<typeof makeSelectFooterSummaryValue>
    >;
    columnUnit?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableColumnUnit>
    >;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableFooterColumnSummaryComponent = (
    props: Props
): React.ReactElement | null => {
    const { footerSummaryValue, columnUnit } = props;

    if (!footerSummaryValue) {
        return null;
    }

    return (
        <React.Fragment>
            {footerSummaryValue.toLocaleString()} {columnUnit}
        </React.Fragment>
    );
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    footerSummaryValue: makeSelectFooterSummaryValue(),
    columnUnit: makeSelectVirtualizedTableColumnUnit()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableFooterColumnSummaryComponent, isEqual)
);
